import Router from 'vue-router';

import Home from '@/view/Home';
import Blank from '@/view/login/Blank';
import Subscribe from '@/view/login/Subscribe';
import RecoverPassword from '@/view/login/RecoverPassword';
import ChangeMotDePasse from '@/view/motdepasse/ChangeMotDePasse';
import RenouvellementMotPasse from '@/view/motdepasse/RenouvellementMotPasse';

import Mentions from '@/view/commun/Mentions';
import RGPD from '@/view/commun/RGPD';

import Recherche from './recherche';
import Workflow from './workflow';
import Administration from './administration';

import authorization from '@/utils/authorization';

// il faut injecter le store car il y a une dependance circulaire
import { initUtils } from '@/utils/base';

const commmon = [
  {
    path: '/',
    redirect: '/login',
  },
  {
    path: '/home',
    name: 'home',
    component: Home,
    meta: {
      auth: 'permit',
    },
  },
  {
    path: '/login',
    name: 'login',
    component: Blank,
    meta: {
      auth: 'permit',
    },
  },
  {
    path: '/subscribe',
    name: 'subscribe',
    component: Subscribe,
    meta: {
      auth: 'permit',
    },
  },
  {
    path: '/subscribe/cniel-infos',
    name: 'subscribeInfo',
    component: Subscribe,
    meta: {
      auth: 'permit',
    },
  },
  {
    path: '/subscribe/sinaps',
    name: 'subscribeSinaps',
    component: Subscribe,
    meta: {
      auth: 'permit',
    },
  },
  {
    path: '/recoverPassword',
    name: 'recoverPassword',
    component: RecoverPassword,
    meta: {
      auth: 'permit',
    },
  },
  {
    path: '/motdepasse/change',
    name: 'changepassword',
    component: ChangeMotDePasse,
    meta: {
      auth: 'permit',
    },
  },
  {
    path: '/motdepasse/oublie',
    name: 'motdepasse/oublie',
    component: RenouvellementMotPasse,
    props: route => ({
      type: 'renouvellement',
      login: route.query.login,
      demande: route.query.demande,
    }),
    meta: {
      auth: 'permit',
    },
  },
  {
    path: '/home/Mentions',
    name: 'home/Mentions',
    component: Mentions,
    meta: {
      auth: 'permit',
      breadcrumb: () => [{ code: 'Mentions légales' }],
    },
  },
  {
    path: '/home/RGPD',
    name: 'home/RGPD',
    component: RGPD,
    meta: {
      auth: 'permit',
      breadcrumb: () => [{ code: 'RGPD' }],
    },
  },
];

const router = new Router({
  mode: 'history',
  routes: commmon
    .concat(Recherche)
    .concat(Workflow)
    .concat(Administration),
});

router.beforeEach((to, from, next) => {
  initUtils(router.app);
  authorization(to, from, next);
});

export default router;
